import React from 'react';

const LoadingTableSkeleton: React.FC = () => {
    return (
        <div role="status" className="animate-pulse w-full my-2 space-y-2">
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse"></div>
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse delay-75"></div>
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse delay-150"></div>
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse delay-300"></div>
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse delay-500"></div>
            <div className="h-10 bg-gradient-to-r from-gray-100 to-gray-50 dark:from-slate-800 dark:to-slate-900/50 rounded animate-pulse delay-700"></div>
        </div>
    );
};

export default LoadingTableSkeleton;


